module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [_vm.block]
  }, [_c('div', {
    class: [_vm.block + '-flex']
  }, [_c('div', {
    class: [_vm.block + '-left']
  }, [((_vm.article.header && !_vm.isMobile)) ? _c('div', {
    class: [_vm.block + '-header'],
    domProps: {
      "innerHTML": _vm._s(_vm.article.header)
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    class: [_vm.block + '-right']
  }, [_c('div', {
    class: [_vm.block + '-imageContainer']
  }, [(_vm.article.imgSrc) ? _c('img', {
    class: [_vm.block + '-image'],
    attrs: {
      "src": _vm.src
    }
  }) : _vm._e(), _vm._v(" "), (_vm.article.date) ? _c('div', {
    class: [_vm.block + '-date'],
    domProps: {
      "innerHTML": _vm._s(_vm.article.date)
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    class: [_vm.block + '-left']
  }, [((_vm.article.header && _vm.isMobile)) ? _c('div', {
    class: [_vm.block + '-header'],
    domProps: {
      "innerHTML": _vm._s(_vm.article.header)
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.article.ingress) ? _c('div', {
    class: [_vm.block + '-ingress'],
    domProps: {
      "innerHTML": _vm._s(_vm.article.ingress)
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.article.sections), function(section, index) {
    return _c('div', [_c('div', _vm._l((section.paragraphs), function(paragraph, index) {
      return (section.paragraphs) ? _c('p', {
        class: [_vm.block + '-paragraph'],
        domProps: {
          "innerHTML": _vm._s(paragraph)
        }
      }) : _vm._e()
    })), _vm._v(" "), (section.quote && section.quote.text) ? _c('div', {
      class: [_vm.block + '-quote']
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(section.quote.text)
      }
    }), _vm._v(" "), _c('div', {
      class: [_vm.block + '-flex m-standardMargin m-wrap']
    }, [(section.quote && section.quote.author) ? _c('div', {
      class: [_vm.block + '-author'],
      domProps: {
        "innerHTML": _vm._s(section.quote.author + ((section.quote.title) ? ',&nbsp;' : ''))
      }
    }) : _vm._e(), _vm._v(" "), (section.quote && section.quote.title) ? _c('div', {
      class: [_vm.block + '-title'],
      domProps: {
        "innerHTML": _vm._s(section.quote.title)
      }
    }) : _vm._e()])]) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    class: [_vm.block + '-backButton'],
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('icon-gb', {
    class: [_vm.block + '-backIcon'],
    attrs: {
      "name": "spotin-com-arrowUpRight",
      "size": "large"
    }
  }), _vm._v(" "), _c('TextLink', {
    attrs: {
      "data": {
        linkText: 'Back',
        route: 'back',
        blockModifiers: ['noMargin']
      }
    }
  })], 1)], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d30ecdd","buble":{"objectAssign":"Object.assign"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/blocks/Article.vue
// module id = 402
// module chunks = 0